import {CssGenerator} from './CssGenerator';


const innerBlocks = function (blocks) {
    let type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let __CSS = '';
    if (type === true) {
        __CSS = '';
        type = false;
    }
    blocks.map(function (row) {
        const attributes = row.attributes,
            name = row.name;

        const blockName = name.split('/');
        if (blockName[0] === 'rtcl' && attributes.blockId) {
            __CSS += CssGenerator(attributes, blockName[1], attributes.blockId, true);
        }
        if (row.innerBlocks && row.innerBlocks.length > 0) {
            __CSS += innerBlocks(row.innerBlocks);
        }
    });
    return __CSS;
};

const isRtclBlock = (blocks) => {
    let hasBlocks = false;
    blocks.forEach(function (element) {
        if (element.name.indexOf('rtcl/') !== -1) {
            hasBlocks = true;
        }
        if (element.innerBlocks && element.innerBlocks.length > 0) {
            element.innerBlocks.forEach(function (el) {
                if (el.name.indexOf('rtcl/') !== -1) {
                    hasBlocks = true;
                }
                if (el.innerBlocks && el.innerBlocks.length > 0) {
                    el.innerBlocks.forEach(function (e) {
                        if (e.name.indexOf('rtcl/') !== -1) {
                            hasBlocks = true;
                        }
                    });
                }
            });
        }
    });
    return hasBlocks;
}

const getData = pId => {

    jQuery
        .ajax({
            url: ajaxurl,
            dataType: "json",
            type: "POST",
            data: {
                postId: pId,
                action: 'rtcl_block_css_get_posts'
            }
        })
        .then(function (response) {
            if (response.success) {
                const innerBlock = innerBlocks(wp.blocks.parse(response.data), true);
                if (innerBlock.css) {
                    jQuery
                        .ajax({
                            url: ajaxurl,
                            dataType: "json",
                            type: "POST",
                            data: {
                                inner_css: innerBlock.css,
                                post_id: wp.data.select('core/editor').getCurrentPostId(),
                                action: 'rtcl_block_css_appended'
                            }
                        })
                        .done(function (res) {
                            if (res.success) {
                                // Save Data
                            }
                        });
                }
            }
        });
};

const parseBlock = blocks => {
    blocks.forEach(function (block) {
        if (block.name.indexOf('core/block') !== -1) {
            getData(block.attributes.ref);
        }
        if (block.innerBlocks && block.innerBlocks.length > 0) {
            parseBlock(block.innerBlocks);
        }
    });
};

const ParseCss = () => {
    window.bindCss = true;
    const all_blocks = wp.data.select('core/block-editor').getBlocks();

    const post_id = wp.data.select('core/editor').getCurrentPostId();

    const hasBlocks = isRtclBlock(all_blocks);
    const blockCss = innerBlocks(all_blocks, true);
    parseBlock(all_blocks);
    jQuery
        .ajax({
            url: ajaxurl,
            dataType: "json",
            type: "POST",
            data: {block_css: blockCss, post_id: post_id, has_block: hasBlocks, action: 'rtcl_block_css_save'}
        });
    setTimeout(function () {
        window.bindCss = false;
    }, 900);
};

export default ParseCss;